export default "__VITE_ASSET__7756e0f1__"